export default __webpack_public_path__ + "static/media/right-arrow.cb20f748.svg";